import { Button, Col, Modal, Row } from 'react-bootstrap';

import {
  formatDate,
  formatNumber,
} from '../../utils/partidasFormatters';
import PartidaEstadoBadge from './PartidaEstadoBadge';

const Detail = ({ label, children }) => (
  <div className='partidas-detail-item'>
    <span>{label}</span>
    <strong>{children ?? '—'}</strong>
  </div>
);

export default function PartidaDetalleModal({ partida, onHide }) {
  return (
    <Modal show={Boolean(partida)} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Detalle de partida</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {partida && (
          <>
            <div className='partidas-detail-heading'>
              <div>
                <span>Artículo {partida.codigo_articulo}</span>
                <h3>{partida.detalle}</h3>
              </div>
              <PartidaEstadoBadge estado={partida.estado_vencimiento} />
            </div>

            <Row className='g-3 partidas-detail-grid'>
              <Col xs={12} md={6}>
                <Detail label='Nº de partida'>{partida.numero_partida}</Detail>
              </Col>
              <Col xs={12} md={6}>
                <Detail label='Proveedor'>{partida.proveedor || 'Sin proveedor'}</Detail>
              </Col>
              <Col xs={6} md={3}>
                <Detail label='Línea (Nivel 1)'>{partida.nivel1}</Detail>
              </Col>
              <Col xs={6} md={3}>
                <Detail label='Nivel 2'>{partida.nivel2}</Detail>
              </Col>
              <Col xs={6} md={3}>
                <Detail label='Nivel 3'>{partida.nivel3}</Detail>
              </Col>
              <Col xs={6} md={3}>
                <Detail label='Nivel 4'>{partida.nivel4}</Detail>
              </Col>
              <Col xs={12} md={6}>
                <Detail label='Fecha de origen'>{formatDate(partida.fecha_origen)}</Detail>
              </Col>
              <Col xs={12} md={6}>
                <Detail label='Fecha de vencimiento'>
                  {formatDate(partida.fecha_vencimiento)}
                </Detail>
              </Col>
              <Col xs={12} md={4}>
                <Detail label='Cantidad entrada'>
                  {formatNumber(partida.cantidad_entrada)}
                </Detail>
              </Col>
              <Col xs={12} md={4}>
                <Detail label='Cantidad salida'>
                  {formatNumber(partida.cantidad_salida)}
                </Detail>
              </Col>
              <Col xs={12} md={4}>
                <Detail label='Cantidad saldo'>
                  {formatNumber(partida.cantidad_saldo)}
                </Detail>
              </Col>
              <Col xs={12} md={6}>
                <Detail label='Estado de origen'>{partida.estado_origen}</Detail>
              </Col>
              <Col xs={12} md={6}>
                <Detail label='Días hasta el vencimiento'>
                  {partida.dias_hasta_vencimiento ?? '—'}
                </Detail>
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
